module.exports = __webpack_public_path__ + "static/bracers_of_defense-d25d308ae8fdbe2048cbd1034afba602.jpeg";